export default "__VITE_ASSET__BvwBsSFq__"